import { useEffect, useState } from "react";

import { env } from "@/env";

import { BackgroundEffects } from "./BackgroundEffects";
import { LoginButton } from "./LoginButton";
import { SuccessCheck } from "./SuccessCheck";
import { SuccessContent } from "./SuccessContent";

interface UserResponse {
	data: {
		user: {
			name: string;
			email: string;
		};
	};
}

export default function ObrigadoMonetizze() {
	const [nome, setNome] = useState<string>("");
	const [, setEmail] = useState<string>("");
	const [pedidoId, setPedidoId] = useState<string>("");
	const [, setUsuarioJaCadastrado] =
		useState<boolean>(false);
	const [loading, setLoading] = useState<boolean>(true);

	useEffect(() => {
		const params = new URLSearchParams(window.location.search);
		const emailParam = params.get("e");
		const pedidoIdParam = params.get("venda");
		const nomeParam = params.get("nome");

		if (!emailParam || !pedidoIdParam) {
			setUsuarioJaCadastrado(false);
			setLoading(false);
			return;
		}

		if (nomeParam) {
			setNome(nomeParam);
		}

		setEmail(emailParam);
		setPedidoId(pedidoIdParam);

		fetch(`${env.VITE_API_URL}/auth/check-user`, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({ email: emailParam }),
		})
			.then((res) => res.json())
			.then((data: UserResponse) => {
				// console.log(data.data);
				if (data?.data?.user?.name && data?.data?.user?.email) {
					setNome(data.data.user.name);
					setUsuarioJaCadastrado(true);
				} else {
					setUsuarioJaCadastrado(false);
				}
			})
			.catch(() => {
				setUsuarioJaCadastrado(false);
			})
			.finally(() => setLoading(false));
	}, []);

	if (loading) {
		return (
			<div className="flex min-h-screen items-center justify-center bg-black text-white">
				<p>Carregando dados...</p>
			</div>
		);
	}

	return (
		<div className="relative min-h-screen overflow-hidden bg-background">
			<BackgroundEffects />

			{/* Background Image Overlay */}
			<div
				className="absolute inset-0 bg-cover bg-center bg-no-repeat opacity-30 contrast-125 grayscale"
				style={{
					backgroundImage: "url('/567d53ae-660b-49df-a764-541177963074.png')",
					filter:
						"sepia(100%) hue-rotate(200deg) saturate(0.3) brightness(1.3)",
					mixBlendMode: "multiply",
				}}
			/>
			{/* <NotificationCarousel /> */}

			<div className="relative z-10 flex min-h-screen flex-col items-center justify-center px-4 py-8 md:px-6 md:py-12">
				<div className="mx-auto w-full max-w-2xl text-center md:max-w-3xl">
					{/* Success Check Animation */}
					<div className="flex justify-center">
						<SuccessCheck />
					</div>

					{/* Main Content */}
					<div className="-mt-2">
						<SuccessContent name={nome} pedidoId={pedidoId} />
					</div>

					{/* Login Button */}
					<div className="flex justify-center pt-2 md:pt-4">
						<LoginButton />
					</div>
				</div>
			</div>

			{/* Rodapé com logo */}
			<footer className="absolute bottom-8 left-1/2 z-10 -translate-x-1/2 transform md:bottom-12">
				<div className="flex items-center justify-center">
					<img
						src="/d3aeeb74-329a-4671-8d1c-b707f9fe6552.png"
						alt="fy. logo"
						className="h-6 opacity-70 transition-opacity duration-300 hover:opacity-100 md:h-8"
					/>
				</div>
			</footer>
		</div>
	);
}
